<template>
  <div class="flex">
    <div
      class="flex flex-col mx-auto p-4 w-full h-full items-center text-blue-800 my-4"
      style="text-align: center"
    >
      <div class="flex flex-col w-full px-12 gap-2">
        <div class="grid grid-cols-1 gap-2">
          <p class="col-span-1 text-left text-xl font-bold">
            {{ $t("bodyprint_declined.title") }}
          </p>
        </div>

        <div class="grid grid-cols-3 gap-4">
          <div class="col-span-2 border-solid border-2 p-4">
            <bodyprint-declined-table
              :items="declinedBodyprints"
              :loading="loading"
              :selected-item="selectedItem"
              @item-selected="item => (selectedItem = item)"
            />
          </div>

          <div v-if="declinedBodyprints.length > 0" class="col-span-1">
            <div
              v-if="!selectedItem"
              class="border-solid border-2 p-4 text-left"
            >
              {{ $t("bodyprint_declined.actions.no_item_selected") }}
            </div>
            <bodyprint-declined-actions
              v-else
              :item="selectedItem"
              :loading="actionLoading"
              @restore="handleRestore"
              @transfer="handleTransfer"
              @remove="handleRemove"
            />
          </div>
        </div>
      </div>
    </div>

    <error-modal
      :showModal="showErrorModal"
      :title="errorTitle"
      :message="errorMessage"
      @close="showErrorModal = false"
    />
  </div>
</template>

<script>
import BodyprintDeclinedTable from "@/components/bodyprint/bodyprint-declined-table.vue";
import BodyprintDeclinedActions from "@/components/bodyprint/bodyprint-declined-actions.vue";
import ErrorModal from "@/components/modals/error-modal.vue";

export default {
  name: "BodyprintDeclinedView",
  components: {
    BodyprintDeclinedTable,
    BodyprintDeclinedActions,
    ErrorModal
  },
  data() {
    return {
      loading: false,
      declinedBodyprints: [],
      selectedItem: null,
      actionLoading: false,
      showErrorModal: false,
      errorTitle: "",
      errorMessage: ""
    };
  },
  created() {
    this.getDeclinedBodyprints();
  },
  methods: {
    getDeclinedBodyprints() {
      this.loading = true;
      this.$store
        .dispatch("bodyprint/getDeclinedBodyprints")
        .then(() => {
          this.declinedBodyprints = this.$store.getters[
            "bodyprint/getDeclinedBodyprints"
          ];
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    showActionError(messageKey) {
      this.errorTitle = this.$t("bodyprint_declined.actions.errors.title");
      this.errorMessage = this.$t(messageKey);
      this.showErrorModal = true;
    },
    handleRestore() {
      this.actionLoading = true;
      this.$store
        .dispatch("bodyprint/restoreDeclinedBodyprint", {
          id: this.selectedItem.id
        })
        .then(() => {
          this.actionLoading = false;
          this.selectedItem = null;
          this.getDeclinedBodyprints();
        })
        .catch(() => {
          this.actionLoading = false;
          this.showActionError(
            "bodyprint_declined.actions.errors.restore_failed"
          );
        });
    },
    handleTransfer(data) {
      this.actionLoading = true;
      this.$store
        .dispatch("bodyprint/transferDeclinedBodyprint", {
          id: this.selectedItem.id,
          data
        })
        .then(() => {
          this.actionLoading = false;
          this.selectedItem = null;
          this.getDeclinedBodyprints();
        })
        .catch(() => {
          this.actionLoading = false;
          this.showActionError(
            "bodyprint_declined.actions.errors.transfer_failed"
          );
        });
    },
    handleRemove() {
      this.actionLoading = true;
      this.$store
        .dispatch("bodyprint/removeDeclinedBodyprint", {
          id: this.selectedItem.id
        })
        .then(() => {
          this.actionLoading = false;
          this.selectedItem = null;
          this.getDeclinedBodyprints();
        })
        .catch(() => {
          this.actionLoading = false;
          this.showActionError(
            "bodyprint_declined.actions.errors.remove_failed"
          );
        });
    }
  }
};
</script>
